import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { images } from "../../helpers/images";
import { onClickWhiteLabelSignup } from "../../modules/actions";
import { authUserData } from "../../helpers";
import Toast from "../../components/Toast";

class WhiteLabelAdminSignup extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      email: "",
      password: "",
      confirmPassword: "",
      disableLogin: false,
      showRegister: true,
      businessName: "",
      website: "",
      subdomain: "",
    };
  }

  componentDidMount() {
    const userData = authUserData();

    if (userData && userData.accessToken) {
      this.props.history.push("/dashboard");
    }
  }

  /* async componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate", this.props)
  } */

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickSignup = () => {
    this.setState({ disableLogin: true });
    this.props.onClickWhiteLabelSignup({
      purpose: "white-label-signup",
      userType: "admin",
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      businessName: this.state.businessName,
      website: this.state.website,
      subdomain: this.state.subdomain,
      logo: "",
    });

    setTimeout(
      () =>
        this.setState({
          email: "",
          password: "",
          confirmPassword: "",
          businessName: "",
          website: "",
          subdomain: "",
          logo: "",
          disableLogin: false,
        }),
      2500
    );
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickSignin(evt);
    }
  };

  render() {
    const {
      email,
      password,
      confirmPassword,
      disableLogin,
      showRegister,
      businessName,
      website,
      subdomain,
    } = this.state;

    return (
      <div className="grid-container full">
        <ToastContainer />
        {/* <Toast
          toast={{
            icon: images.checkIcon,
            title: "Success",
            description: "Sign up successfull.",
            backgroundColor: "#66cc3e",
          }}
          position={"top-right"}
          autoDeleteTime={3500}
        /> */}

        <div className="grid-x  grid-margin-x" id="container">
          <div className="cell small-12 medium-5" id="infoplatesection">
            <div id="logosection">
              <img src={images.logo} />
            </div>

            <div id="infotxt">
              White label signup here
              <br />
              and create
            </div>

            <div id="infobutton">
              <Link to="/signup">
                <button className="button login active" id="loginBtn">
                  Sign up
                </button>
              </Link>
              <p> or </p>{" "}
              <Link to="/subdomain">
                <button className="button login" id="loginBtn">
                  Enter Subdomain
                </button>
              </Link>
            </div>
          </div>
          <div className="cell small-12 medium-7" id="formsection">
            <div
              id="registersaq"
              className={(showRegister === true && "show") || "hide"}
            >
              <h3 style={{ paddingTop: "200px" }}>Sign up</h3>
              <p>Create your white label accout</p>
              <form>
                <div className="grid-container" id="formfieldscontainer">
                  <div className="grid-y grid-x">
                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter email"
                          name="email"
                          value={email}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>
                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter password"
                          name="password"
                          value={password}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>

                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter confirm password"
                          name="confirmPassword"
                          value={confirmPassword}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>

                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter business name"
                          name="businessName"
                          value={businessName}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>

                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter website"
                          name="website"
                          value={website}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>

                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter subdomain"
                          name="subdomain"
                          value={subdomain}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>

                  </div>
                  <div id="fieldbuttons">
                    {/* <button className="button nxt-btn">Create Account</button> */}
                    <button
                      type="button"
                      className="button nxt-btn"
                      onClick={() => this.onClickSignup()}
                      disabled={disableLogin}
                    >
                      Sign up
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickWhiteLabelSignup }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteLabelAdminSignup);
